// @flow
import styled from '@emotion/styled';
import Button from '@tablekit/button';
import { SPACING } from '@tablekit/theme';
import { LAPTOP_BREAKPOINT, MAX_WIDTH } from 'utils/theme';
import columnWidth from 'utils/columnWidth';

export const BLOG_MAX_WIDTH = parseInt(MAX_WIDTH, 10) * columnWidth(8);

// Content should be 8 columns wide with 2 columns padding
export const PostBody = styled.div`
  position: relative;
  padding: 0 ${SPACING.L4};

  @media ${LAPTOP_BREAKPOINT} {
    width: 66.66vw;
    max-width: ${BLOG_MAX_WIDTH}px;
    margin: 0 auto;
    padding: 0 0 ${SPACING.L9};
  }
`;

export const SummaryButton = styled(Button)`
  align-self: center;
`;
